/**
 * Shared types, constants, and helpers for answer validators.
 *
 * Extracted from validatorRegistry.ts during R1-S1 god-file split.
 */

import type { Question } from '../../types';
import type { ValidationResult } from '../../../practice/logic/answerProtocol';

// ── Types ────────────────────────────────────────────────────

export type ValidatorFn = (userAnswer: string | number, question: Question) => ValidationResult;

// ── Constants ────────────────────────────────────────────────

/** Shared numeric comparison tolerance for floating-point answers (R2-MN2) */
export const NUMERIC_TOLERANCE = 0.001;

// ── Helpers ──────────────────────────────────────────────────

/**
 * Normalize a numeric string for comparison.
 * Handles Dutch/EU formatting (comma as decimal, dot as thousands separator).
 */
export function normalizeNumeric(val: string): string {
  let cleaned = val.trim().replace(/[€\s]/g, '');
  if (cleaned.includes('.') && cleaned.includes(',')) {
    cleaned = cleaned.replace(/\./g, '').replace(',', '.');
  } else if (cleaned.includes(',')) {
    cleaned = cleaned.replace(',', '.');
  } else if (cleaned.includes('.')) {
    // Check if dots are thousands separators (e.g., "1.200" = 1200)
    if (/^\d{1,3}(\.\d{3})+$/.test(cleaned)) {
      cleaned = cleaned.replace(/\./g, '');
    }
  }
  return cleaned;
}